import type { INode } from '@mrblenny/react-flow-chart/src/types/chart.js';
import type IntentNodeProperties from './intentNodeProperties.ts';

export enum CustomNodeTypeEnum {
  Normal = 'normal',
  Start = 'start',
  End = 'end',
  Service = 'service'
}

export type CustomNodeType = CustomNodeTypeEnum;

export type CustomNode = INode<IntentNodeProperties>;
